import { useCallback } from 'react';
import { Select, SelectItem, SelectSizesXL } from '@picsart/design-system/components/Select';
import { useTranslator } from '@picsart/rc/services/localization';
import { removeHyphens } from './utils';
import { ITemplateCategoryFilter } from './types';
import useStyles from './styles';

const TemplateCategoryFilter = ({
  filterData,
  filterType,
  setFilterType,
}: ITemplateCategoryFilter) => {
  const classes = useStyles();
  const translate = useTranslator();

  const handleFilterChange = useCallback(
    (value: string) => {
      setFilterType(value);
    },
    [setFilterType],
  );

  return (
    <Select
      dataTestId="select-test"
      className={classes.selector}
      label={translate('Search in')}
      value={removeHyphens(filterType)}
      size={SelectSizesXL}
      onChange={handleFilterChange}
      data-pulse-section="filters"
      data-pulse-section-group="search"
      pulseName={filterData[0]}
      autoCloseOnScroll
    >
      {filterData.map(label => (
        <SelectItem
          key={label}
          className={classes.selectorItem}
          value={removeHyphens(label)}
          data-pulse-name={label}
          data-pulse-section="filters"
          data-pulse-section-group="search"
        >
          {translate(removeHyphens(label))}
        </SelectItem>
      ))}
    </Select>
  );
};

export default TemplateCategoryFilter;
